import Button from "@common/components/Button";
import { FavouriteOnIcon } from "@common/components/icons";
import { Trans, useTranslation } from "next-i18next";
import { VLP_PATH } from "@common/helpers/isVehicleListingPage";
import Link from "next/link";
import useGetVehicleFilterData from "@modules/vehicle/hooks/useVehicleFilterData";
import ShopByBodyStyle from "./ShopByBodyStyle";
import ShopPopularBrands from "./ShopPopularBrands";

const EmptySavedVehicles = () => {
  const { t } = useTranslation(["common", "profile"]);
  const { vehicleFilters: vehicleFiltersData, isLoading: isFiltersLoading } =
    useGetVehicleFilterData();

  return (
    <div className="py-4">
      <Trans t={t} i18nKey="profile:empty_saved_vehicles_message">
        <p className="body-4 text-text-light-200" />
        <span className="inline-block body-4 pt-3 text-text-light-200">
          <FavouriteOnIcon className="text-secondary-salmon -mt-2 mx-[1px] w-6 h-6 inline" />
        </span>
      </Trans>

      {!isFiltersLoading && (
        <>
          <div className="max-w-4xl">
            <div className="mt-5">
              <ShopByBodyStyle bodyStyles={vehicleFiltersData?.bodyStyles} />
            </div>
            <div className="mt-6">
              <ShopPopularBrands
                brands={vehicleFiltersData?.makesAndModels.map((x) => x.name)}
              />
            </div>
          </div>

          <div className="my-12">
            <Link href={`/${VLP_PATH}`}>
              <Button buttonStyle="primary" fill="filled">
                {t("common:shop_all_inventory")}
              </Button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default EmptySavedVehicles;
